export const hasCertificadosReadPermission = (user) => {
  const read = user?.permissionWebAssistencia?.certificados?.read;
  return read === true || read === 'true' || read === 1;
};

export const buildCertificadoDownloadUrl = (serialnumber, cupid) => {
  if (!serialnumber || !cupid) return '';
  return `${process.env.REACT_APP_API_FILE_SERVER}/download/certificado/${serialnumber}-${cupid}`;
};

/**
 * Ex.: "FBMT-03257-1744353349.html" → série "FBMT-03257", id "1744353349"
 * O segundo hífen separa o número de série do id.
 */
export const parseCertificadoFileName = (fileName) => {
  const raw = String(fileName || '').trim();
  if (!raw) return null;

  const base = raw.replace(/\.html$/i, '');
  const firstHyphen = base.indexOf('-');
  if (firstHyphen === -1) return null;

  const secondHyphen = base.indexOf('-', firstHyphen + 1);
  if (secondHyphen === -1) return null;

  const serialnumber = base.slice(0, secondHyphen);
  const cupid = base.slice(secondHyphen + 1);

  if (!serialnumber || !cupid) return null;

  return {
    serialnumber,
    cupid,
    fileName: /\.html$/i.test(raw) ? raw : `${raw}.html`,
  };
};

export const mapCertificadoFilesToCertificados = (files = []) => {
  const parsedList = files
    .map((item) => {
      if (typeof item === 'string') {
        return parseCertificadoFileName(item);
      }
      if (item?.serialnumber && item?.cupid) {
        return {
          serialnumber: item.serialnumber,
          cupid: String(item.cupid),
          fileName: item.fileName || `${item.serialnumber}-${item.cupid}.html`,
        };
      }
      return parseCertificadoFileName(item?.fileName || item?.name || '');
    })
    .filter(Boolean);

  return parsedList.map((parsed, index) => {
    const id = `${parsed.serialnumber}-${parsed.cupid}`;
    return {
      _id: id,
      id,
      serialnumber: parsed.serialnumber,
      cupid: parsed.cupid,
      fileName: parsed.fileName,
      listOrder: index,
      downloadUrl: buildCertificadoDownloadUrl(parsed.serialnumber, parsed.cupid),
    };
  });
};
